module.exports = __webpack_public_path__ + "static/media/b-icon-white.3343527a.svg";